<template>
  <div class="card shadow" ref="errosGerais">
    <div class="card-header">
      <h3 class="card-title" v-if="this.add">
        <img
          src="media/icons/duotune/general/gen055.svg"
          class="me-2"
        />Adicionar
      </h3>
      <h3 class="card-title" v-else>
        <img src="media/icons/duotune/general/gen055.svg" class="me-2" />Editar
      </h3>
      <div class="card-toolbar">
        <router-link
          to="/principal/revenda/distribuidormaster"
          class="btn btn-sm btn-light"
        >
          <span class="svg-icon svg-icon-1">
            <inline-svg src="media/icons/duotune/arrows/arr079.svg" />
          </span>
          Voltar
        </router-link>
      </div>
    </div>
    <div class="card-body">
      <div v-bind:data-kt-indicator="loading ? 'on' : 'off'">
        <span class="indicator-progress">
          Aguarde, carregando...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
        <div
          v-if="this.errosGerais.Message"
          class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
        >
          <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
            <inline-svg src="media/icons/duotune/general/gen044.svg" />
          </span>
          <div class="d-flex flex-stack flex-grow-1">
            <div class="fw-bold">
              <h4 class="text-gray-800 fw-bolder">Aviso</h4>
              <div class="fs-6 text-gray-600">
                {{ this.errosGerais.Message }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 mb-4">
            <label for="txtNome" class="required form-label"
              >Nome / Razão social</label
            >
            <input
              type="text"
              id="txtNome"
              :value="
                (distribuidorMaster.nome =
                  distribuidorMaster.nome.toUpperCase())
              "
              @input="
                distribuidorMaster.nome = $event.target.value.toUpperCase()
              "
              class="form-control"
              data-kt-toggle="true"
              data-kt-toggle-state="active"
            />
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["nome"] }}
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-7 col-xl-3 col-xxl-3 mb-4">
            <label for="txtFantasia" class="required form-label"
              >Fantasia</label
            >
            <input
              type="text"
              id="txtFantasia"
              class="form-control"
              :value="
                (distribuidorMaster.fantasia = distribuidorMaster.fantasia
                  ? distribuidorMaster.fantasia.toUpperCase()
                  : '')
              "
              @input="
                distribuidorMaster.fantasia = $event.target.value.toUpperCase()
              "
            />
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["fantasia"] }}
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-5 col-xl-3 col-xxl-3 mb-4">
            <label for="txtResponsavel" class="form-label">Responsável</label>
            <input
              type="text"
              id="txtResponsavel"
              class="form-control"
              v-model="distribuidorMaster.responsavel"
            />
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["responsavel"] }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-6 col-xl-3 col-xxl-3 mb-4">
            <label for="txtCNPJ" class="required form-label">CNPJ</label>
            <div class="input-group">
              <input
                type="text"
                id="txtCNPJ"
                class="form-control"
                v-mask="'##.###.###/####-##'"
                v-model="distribuidorMaster.cnpj"
                @keyup.enter="pesquisarCNPJ()"
              />
              <button
                @click.prevent="pesquisarCNPJ()"
                class="input-group-text"
                v-bind:data-kt-indicator="loadingCNPJ ? 'on' : 'off'"
              >
                <span class="svg-icon svg-icon-2" v-if="!loadingCNPJ">
                  <inline-svg src="media/icons/duotune/general/gen004.svg" />
                </span>
                <span class="indicator-progress">
                  <span
                    class="spinner-border align-middle"
                    style="width: 1.5rem; height: 1.5rem"
                  ></span>
                </span>
              </button>
            </div>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["cnpj"] }}
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-6 col-xl-3 col-xxl-3 mb-4">
            <label for="txtIE" class="required form-label"
              >Inscrição estadual</label
            >
            <input
              type="text"
              id="txtIE"
              class="form-control"
              v-model="distribuidorMaster.ie"
            />
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["ie"] }}
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-6 col-xl-3 col-xxl-3 mb-4">
            <label for="txtRegiao" class="required form-label">Região</label>
            <input
              type="text"
              id="txtRegiao"
              class="form-control"
              v-model="distribuidorMaster.regiao"
            />
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["regiao"] }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-3 col-xl-2 col-xxl-2 mb-4">
            <label for="txtCEP" class="required form-label">CEP</label>
            <div class="input-group">
              <input
                type="text"
                id="txtCEP"
                class="form-control"
                v-mask="'#####-###'"
                v-model="distribuidorMaster.cep"
                @keyup.enter="pesquisarCep()"
              />
              <button
                @click.prevent="pesquisarCep()"
                class="input-group-text"
                v-bind:data-kt-indicator="loadingCep ? 'on' : 'off'"
              >
                <span class="svg-icon svg-icon-2" v-if="!loadingCep">
                  <inline-svg src="media/icons/duotune/general/gen004.svg" />
                </span>
                <span class="indicator-progress">
                  <span
                    class="spinner-border align-middle"
                    style="width: 1.5rem; height: 1.5rem"
                  ></span>
                </span>
              </button>
            </div>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["cep"] }}
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-9 col-xl-5 col-xxl-5 mb-4">
            <label for="txtEndereco" class="required form-label"
              >Endereço</label
            >
            <input
              type="text"
              id="txtEndereco"
              class="form-control"
              v-model="distribuidorMaster.endereco"
            />
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["endereco"] }}
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-4 col-xl-2 col-xxl-2 mb-4">
            <label for="txtNumero" class="required form-label">Número</label>
            <input
              type="text"
              id="txtNumero"
              class="form-control"
              v-model="distribuidorMaster.numero"
            />
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["numero"] }}
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-8 col-xl-3 col-xxl-3 mb-4">
            <label for="txtComplemento" class="form-label">Complemento</label>
            <input
              type="text"
              id="txtComplemento"
              class="form-control"
              v-model="distribuidorMaster.complemento"
            />
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["complemento"] }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-8 col-xl-4 col-xxl-3 mb-4">
            <label for="txtBairro" class="required form-label">Bairro</label>
            <input
              type="text"
              id="txtBairro"
              class="form-control"
              v-model="distribuidorMaster.bairro"
            />
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["bairro"] }}
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-4 col-xl-2 col-xxl-3 mb-4">
            <label for="cboUF" class="required form-label">UF</label>
            <select
              class="form-select"
              aria-label="UF"
              v-model="distribuidorMaster.uf"
            >
              <option value="AC">Acre</option>
              <option value="AL">Alagoas</option>
              <option value="AP">Amapá</option>
              <option value="AM">Amazonas</option>
              <option value="BA">Bahia</option>
              <option value="CE">Ceara</option>
              <option value="DF">Distrito Federal</option>
              <option value="ES">Espirito Santo</option>
              <option value="GO">Goiás</option>
              <option value="MA">Maranhão</option>
              <option value="MT">Mato Grosso</option>
              <option value="MS">Mato Grosso do Sul</option>
              <option value="MG">Minas Gerais</option>
              <option value="PA">Para</option>
              <option value="PB">Paraíba</option>
              <option value="PR">Paraná</option>
              <option value="PE">Pernambuco</option>
              <option value="PI">Piauí</option>
              <option value="RJ">Rio de Janeiro</option>
              <option value="RN">Rio Grande do Norte</option>
              <option value="RS">Rio Grande do Sul</option>
              <option value="RO">Rondônia</option>
              <option value="RR">Roraima</option>
              <option value="SC">Santa Catarina</option>
              <option value="SP">São Paulo</option>
              <option value="SE">Sergipe</option>
              <option value="TO">Tocantins</option>
            </select>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["uf"] }}
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-7 col-xl-4 col-xxl-3 mb-4">
            <label for="txtCidade" class="required form-label">Cidade</label>
            <div class="input-group">
              <input
                type="text"
                id="txtCidade"
                class="form-control"
                :value="
                  distribuidorMaster.cidade
                    ? distribuidorMaster.cidade.toUpperCase()
                    : ''
                "
                @input="
                  distribuidorMaster.cidade = $event.target.value.toUpperCase()
                "
              />
              <button
                class="input-group-text"
                @click.prevent="modalCidades(true)"
              >
                <span class="svg-icon svg-icon-2">
                  <inline-svg src="media/icons/duotune/general/gen004.svg" />
                </span>
              </button>
            </div>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["cidade"] }}
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-5 col-xl-2 col-xxl-3 mb-4">
            <label for="txtPais" class="required form-label">País</label>
            <div class="input-group">
              <input
                type="text"
                id="txtPais"
                class="form-control"
                :value="
                  distribuidorMaster.pais
                    ? distribuidorMaster.pais.toUpperCase()
                    : ''
                "
                @input="
                  distribuidorMaster.pais = $event.target.value.toUpperCase()
                "
              />
              <button
                class="input-group-text"
                @click.prevent="modalPaises(true)"
              >
                <span class="svg-icon svg-icon-2">
                  <inline-svg src="media/icons/duotune/general/gen004.svg" />
                </span>
              </button>
            </div>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["pais"] }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-6 col-xl-3 col-xxl-3 mb-4">
            <label for="txtTelefone" class="form-label">Telefone</label>
            <div class="input-group">
              <span class="input-group-text" id="basic-addon3">
                <i class="bi bi-telephone fs-3"></i>
              </span>
              <input
                type="text"
                id="txtTelefone"
                class="form-control"
                v-mask="'(##) ####-####'"
                v-model="distribuidorMaster.telefone"
              />
            </div>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["telefone"] }}
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-6 col-xl-3 col-xxl-3 mb-4">
            <label for="txtCelular" class="form-label">Celular</label>
            <div class="input-group">
              <span class="input-group-text" id="basic-addon3">
                <i class="bi bi-phone fs-3"></i>
              </span>
              <input
                type="text"
                id="txtCelular"
                class="form-control"
                v-mask="['(##) ####-####', '(##) #####-####']"
                v-model="distribuidorMaster.fax"
              />
            </div>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["fax"] }}
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 col-xxl-6 mb-4">
            <label for="txtEmail" class="form-label required">Email</label>
            <div class="input-group">
              <span class="input-group-text" id="basic-addon3">
                <i class="bi bi-at fs-3"></i>
              </span>
              <input
                type="text"
                id="txtEmail"
                class="form-control"
                v-model="distribuidorMaster.email"
              />
            </div>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["email"] }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-6 col-xl-4 col-xxl-4 mb-4">
            <label for="txtSite" class="form-label">Site</label>
            <div class="input-group">
              <span class="input-group-text" id="basic-addon3">
                <i class="bi bi-globe2 fs-3"></i>
              </span>
              <input
                type="text"
                id="txtSite"
                class="form-control"
                v-model="distribuidorMaster.site"
              />
            </div>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["site"] }}
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-6 col-xl-3 col-xxl-3 mb-4">
            <label for="txtSite" class="required form-label"
              >Ramo de atividade</label
            >
            <select
              class="form-select"
              aria-label="ramo"
              v-model="distribuidorMaster.ramo"
            >
              <option value="0">Comércio</option>
              <option value="1">Farmácia</option>
              <option value="2">Restaurante</option>
              <option value="3">Posto de Combustível</option>
              <option value="4">Indústria</option>
              <option value="5">Transportadora</option>
            </select>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["ramo"] }}
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-6 col-xl-3 col-xxl-3 mb-4">
            <label for="txtCRT" class="required form-label text-danger"
              >Código de Regime Tributário</label
            >
            <select
              class="form-select"
              aria-label="crt"
              v-model="distribuidorMaster.crt"
            >
              <option value="1">1 - Simples Nacional</option>
              <option value="2">
                2 - Simples Nacional - excesso de sublimite de receita
              </option>
              <option value="3">3 - Regime Normal</option>
            </select>
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["crt"] }}
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-6 col-xl-3 col-xxl-3 mb-4">
            <div class="mb-4 mt-2">
              <div
                class="form-check form-switch form-check-custom form-check-solid"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="flexSwitchChecked"
                  v-model="distribuidorMaster.ativo"
                />
                <label class="form-check-label" for="flexSwitchChecked"
                  >Ativo</label
                >
              </div>
            </div>
            <div class="mb-4">
              <div
                class="form-check form-switch form-check-custom form-check-solid"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="flexSwitchChecked"
                  v-model="distribuidorMaster.producao"
                />
                <label class="form-check-label" for="flexSwitchChecked"
                  >Produção</label
                >
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <label for="imgLogo" class="form-label">Logo</label>
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-4">
            <div
              id="imgLogo"
              class="image-input image-input-outline"
              data-kt-image-input="true"
            >
              <div
                class="image-input-wrapper imagePreviewWrapper w-150px h-150px"
                v-if="this.distribuidorMaster.logo"
                :style="{
                  'background-image': `url(${distribuidorMaster.logo})`,
                }"
              ></div>
              <div
                class="image-input-wrapper imagePreviewWrapper w-150px h-150px"
                v-else
                :style="{
                  'background-image': `url(media/svg/avatars/blank.svg)`,
                }"
              ></div>
              <label
                class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-white shadow"
                data-kt-image-input-action="change"
                data-bs-toggle="tooltip"
                data-bs-dismiss="click"
                title="Alterar logo"
              >
                <i class="bi bi-pencil-fill fs-7"></i>
                <input
                  ref="fileInput"
                  type="file"
                  name="avatar"
                  accept=".png, .jpg, .jpeg"
                  @input="pickFile"
                />
                <input type="hidden" name="avatar_remove" />
              </label>
              <span
                class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-white shadow"
                data-kt-image-input-action="remove"
                data-bs-toggle="tooltip"
                @click="removerLogo()"
                data-bs-dismiss="click"
                title="Remover logo"
              >
                <i class="bi bi-x fs-2"></i>
              </span>
            </div>
            <div class="form-text mt-4">
              Tipo de arquivos aceitos: .png, .jpg, .jpeg.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-4">
            <label for="txtObservacoes" class="form-label">Observações</label>
            <textarea
              id="txtObservacoes"
              class="form-control mb-2"
              placeholder="Observações"
              maxlength="5000"
              style="height: 250px"
              v-model="distribuidorMaster.obs"
            />
            <div class="fv-plugins-message-container invalid-feedback">
              {{ errosValidacao["obs"] }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-4">
        <button
          class="btn btn-success svg-icon-white me-2 mb-2"
          type="submit"
          @click.prevent="confirmar()"
          v-bind:data-kt-indicator="loadingConfirmar ? 'on' : 'off'"
        >
          <span class="indicator-progress">
            <span
              class="spinner-border spinner-border-sm align-middle ms-1"
            ></span>
            Aguarde...
          </span>
          <span class="svg-icon svg-icon-1" v-if="!loadingConfirmar">
            <inline-svg
              src="media/icons/duotune/arrows/arr016.svg"
              class="me-2"
            />Confirmar
          </span>
        </button>
        <router-link to="/principal/revenda/distribuidormaster">
          <a class="btn btn-danger svg-icon-white mb-2">
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-4"
              />Cancelar
            </span>
          </a>
        </router-link>
      </div>
    </div>
  </div>
  <CidadesModal
    v-if="exibirCidades"
    @exibirModalCidades="modalCidades"
    @confirmarCidade="confirmarCidade"
  ></CidadesModal>
  <PaisesModal
    v-if="exibirPaises"
    @exibirModalPaises="modalPaises"
    @confirmarPais="confirmarPais"
  ></PaisesModal>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import CidadesModal from "@/views/cidades/CidadesModal.vue";
import { mapState } from "vuex";
import PaisesModal from "@/views/paises/PaisesModal";
import { useToast } from "vue-toastification";
import { getOrCreateInstanceModal } from "@/core/helpers/dom";
const toast = useToast();

const distribuidorMasterInicializado = {
  nome: "",
  fantasia: "",
  endereco: "",
  complemento: "",
  bairro: "",
  numero: "",
  cep: "",
  cidade: "",
  cod_cidade: "",
  uf: "SP",
  cod_uf: 0,
  telefone: "",
  pais: "",
  cod_pais: "",
  fax: "",
  email: "",
  site: "",
  cnpj: "",
  ie: "",
  responsavel: "",
  ramo: "0",
  regmun: "",
  cnae: "",
  inscricao_municipal: "",
  guid: "",
  producao: true,
  logo: "",
  ativo: true,
  formFile: null,
  logoRemover: "",
  crt: "1",
  obs: "",
  regiao: "",
};

export default {
  components: {
    CidadesModal,
    PaisesModal,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    async confirmar() {
      this.loading = true;
      this.loadingConfirmar = true;
      this.distribuidorMaster.ativo = this.$utils.booleanToString(
        this.distribuidorMaster.ativo
      );
      this.distribuidorMaster.producao = this.$utils.booleanToString(
        this.distribuidorMaster.producao
      );
      this.distribuidorMaster.logo =
        this.distribuidorMaster.logo === null
          ? ""
          : this.distribuidorMaster.logo.replace(this.$utils.getUrl(), "");
      this.distribuidorMaster.responsavel =
        this.distribuidorMaster.responsavel === null
          ? ""
          : this.distribuidorMaster.responsavel;
      this.distribuidorMaster.complemento =
        this.distribuidorMaster.complemento === null
          ? ""
          : this.distribuidorMaster.complemento;
      this.distribuidorMaster.telefone =
        this.distribuidorMaster.telefone === null
          ? ""
          : this.distribuidorMaster.telefone;
      this.distribuidorMaster.fax =
        this.distribuidorMaster.fax === null ? "" : this.distribuidorMaster.fax;
      this.distribuidorMaster.email =
        this.distribuidorMaster.email === null
          ? ""
          : this.distribuidorMaster.email;
      this.distribuidorMaster.site =
        this.distribuidorMaster.site === null
          ? ""
          : this.distribuidorMaster.site;
      this.distribuidorMaster.regmun =
        this.distribuidorMaster.regmun === null
          ? ""
          : this.distribuidorMaster.regmun;
      this.distribuidorMaster.cnae =
        this.distribuidorMaster.cnae === null
          ? ""
          : this.distribuidorMaster.cnae;
      this.distribuidorMaster.inscricao_municipal =
        this.distribuidorMaster.inscricao_municipal === null
          ? ""
          : this.distribuidorMaster.inscricao_municipal;

      this.distribuidorMaster.cnpj = this.$utils.unMask(
        this.distribuidorMaster.cnpj
      );

      this.distribuidorMaster.obs =
        this.distribuidorMaster.obs === null ? "" : this.distribuidorMaster.obs;

      this.distribuidorMaster.regiao =
        this.distribuidorMaster.regiao === null
          ? ""
          : this.distribuidorMaster.regiao;

      if (this.add === true) {
        this.distribuidorMaster.guid = this.$utils.generateUuidv4();
        this.distribuidorMaster.id_software_house =
          this.user.User.id_software_house;

        var formData = new FormData();
        for (var key in this.distribuidorMaster) {
          formData.append(key, this.distribuidorMaster[key]);
        }

        try {
          var retPost = await this.$store.dispatch(
            "distribuidorMaster/postDistribuidorMaster",
            formData
          );
          if (retPost.Success === true) {
            toast.success("Distribuidor Master cadastrado com sucesso!", {
              timeout: 3000,
            });
            this.$router.push("/principal/revenda/distribuidormaster");
          }
        } catch (error) {
          this.errosGerais = error;
          this.errosValidacao = error;
        }
      } else {
        var formDataPut = new FormData();
        for (var keyPut in this.distribuidorMaster) {
          formDataPut.append(keyPut, this.distribuidorMaster[keyPut]);
        }

        try {
          var retPut = await this.$store.dispatch(
            "distribuidorMaster/putDistribuidorMaster",
            formDataPut
          );
          if (retPut.Success === true) {
            toast.success("Distribuidor Master atualizado com sucesso!", {
              timeout: 3000,
            });
            this.$router.push("/principal/revenda/distribuidormaster");
          }
        } catch (error) {
          this.errosGerais = error;
          this.errosValidacao = error;
        }
      }

      if (this.errosGerais.Message) {
        this.scroll("errosGerais");
      }

      this.distribuidorMaster.ativo = this.$utils.stringToBoolean(
        this.distribuidorMaster.ativo
      );
      this.distribuidorMaster.producao = this.$utils.stringToBoolean(
        this.distribuidorMaster.producao
      );

      if (
        this.distribuidorMaster.logo !== "" &&
        !this.distribuidorMaster.logo.includes("base64")
      ) {
        this.distribuidorMaster.logo =
          this.$utils.getUrl() + this.distribuidorMaster.logo;
      }

      this.loadingConfirmar = false;
      this.loading = false;
    },
    removerLogo() {
      this.distribuidorMaster.logoRemover =
        this.distribuidorMaster.logo.replace(this.$utils.getUrl(), "");
      this.distribuidorMaster.logo = "";
      this.distribuidorMaster.formFile = null;
      this.$refs.fileInput.value = null;
    },
    limparDistribuidorMaster() {
      this.distribuidorMaster = JSON.parse(
        JSON.stringify(distribuidorMasterInicializado)
      );

      this.errosGerais = [];
      this.errosValidacao = {};
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          if (this.distribuidorMaster.logo !== null) {
            this.distribuidorMaster.logoRemover =
              this.distribuidorMaster.logo.replace(this.$utils.getUrl(), "");
          }

          this.distribuidorMaster.logo = e.target.result;
          this.distribuidorMaster.formFile = file[0];
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },
    modalCidades(exibir) {
      this.exibirCidades = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_cidades");
        }, 100);
      }
    },
    confirmarCidade(cidade) {
      this.distribuidorMaster.cidade = cidade.cidade;
      this.distribuidorMaster.cod_cidade = cidade.codcidade;
      this.distribuidorMaster.uf = cidade.uf;
      this.distribuidorMaster.cod_pais = "1058";
      this.distribuidorMaster.pais = "BRASIL";
    },
    modalPaises(exibir) {
      this.exibirPaises = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_paises");
        }, 100);
      }
    },
    confirmarPais(pais) {
      this.distribuidorMaster.cod_pais = pais.codbacen;
      this.distribuidorMaster.pais = pais.descricao;
    },
    scroll(refName) {
      let el = this.$refs[refName];
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    },
    async carregarDistribuidorMaster() {
      var id = this.$route.params.id;
      try {
        var ret = await this.$store.dispatch(
          "distribuidorMaster/getDistribuidorMaster",
          id
        );
        if (ret.Success === true) {
          if (ret.Data !== null) {
            this.add = false;
            this.distribuidorMaster = ret.Data;
            this.logoAtual = this.distribuidorMaster.logo;

            this.distribuidorMaster.ativo = this.$utils.stringToBoolean(
              this.distribuidorMaster.ativo
            );
            this.distribuidorMaster.producao = this.$utils.stringToBoolean(
              this.distribuidorMaster.producao
            );

            if (this.distribuidorMaster.logo !== null) {
              this.distribuidorMaster.logo =
                this.$utils.getUrl() + this.distribuidorMaster.logo;
            }
          } else {
            this.errosGerais = ret;
          }
        }
      } catch (error) {
        this.errosGerais = error;
        this.errosValidacao = error;
      }
      if (this.errosGerais.Message) {
        this.scroll("errosGerais");
      }
      this.loading = false;
    },
    async pesquisarCep() {
      this.loadingCep = true;
      if (
        this.distribuidorMaster.cep !== null &&
        this.distribuidorMaster.cep != ""
      ) {
        try {
          var ret = await this.$store.dispatch(
            "cep/getCep",
            this.distribuidorMaster.cep
          );
          if (ret.Success === true) {
            if (ret.Data !== null) {
              this.distribuidorMaster.endereco = ret.Data.logradouro;
              this.distribuidorMaster.bairro = ret.Data.bairro;
              this.distribuidorMaster.complemento = ret.Data.complemento;
              this.distribuidorMaster.cod_cidade = ret.Data.ibge;
              this.distribuidorMaster.cidade = ret.Data.localidade
                ? ret.Data.localidade.toUpperCase()
                : "";
              this.distribuidorMaster.uf = ret.Data.uf;
              this.distribuidorMaster.pais = "BRASIL";
              this.distribuidorMaster.cod_pais = "1058";
            }
          }
        } catch (error) {
          await Swal.fire({
            text: "Não foi possível localizar o CEP!",
            icon: "warning",
            buttonsStyling: false,
            confirmButtonText: "OK",
            customClass: {
              confirmButton: "btn fw-bold btn-warning",
            },
          });
        }
      }
      this.loadingCep = false;
    },
    async pesquisarCNPJ() {
      this.loadingCNPJ = true;
      if (
        this.distribuidorMaster.cnpj &&
        this.distribuidorMaster.cnpj !== null &&
        this.distribuidorMaster.cnpj != ""
      ) {
        try {
          if (this.$utils.validarCPFCNPJ(this.distribuidorMaster.cnpj)) {
            var ret = await this.$utils.consultarCNPJ(
              this.distribuidorMaster.cnpj
            );
            if (ret.data) {
              const dadosCNPJ = ret.data;
              this.distribuidorMaster.nome = dadosCNPJ.razao_social;
              this.distribuidorMaster.fantasia =
                dadosCNPJ.estabelecimento.nome_fantasia;
              this.distribuidorMaster.endereco =
                dadosCNPJ.estabelecimento.logradouro;
              this.distribuidorMaster.complemento =
                dadosCNPJ.estabelecimento.complemento;
              this.distribuidorMaster.bairro = dadosCNPJ.estabelecimento.bairro;
              this.distribuidorMaster.numero = dadosCNPJ.estabelecimento.numero;
              this.distribuidorMaster.cep = dadosCNPJ.estabelecimento.cep;
              this.distribuidorMaster.cidade =
                dadosCNPJ.estabelecimento.cidade.nome;
              this.distribuidorMaster.cod_cidade =
                dadosCNPJ.estabelecimento.cidade.ibge_id;
              this.distribuidorMaster.uf =
                dadosCNPJ.estabelecimento.estado.sigla;
              this.distribuidorMaster.cod_uf =
                dadosCNPJ.estabelecimento.estado.id;
              this.distribuidorMaster.telefone =
                dadosCNPJ.estabelecimento.ddd1 +
                dadosCNPJ.estabelecimento.telefone1;
              this.distribuidorMaster.pais =
                dadosCNPJ.estabelecimento.pais.nome;
              this.distribuidorMaster.cod_pais =
                dadosCNPJ.estabelecimento.pais.id;
              this.distribuidorMaster.email = dadosCNPJ.estabelecimento.email;
              this.distribuidorMaster.pais =
                dadosCNPJ.estabelecimento.pais.nome;
              if (
                dadosCNPJ.estabelecimento.inscricoes_estaduais &&
                dadosCNPJ.estabelecimento.inscricoes_estaduais.length > 0
              ) {
                this.distribuidorMaster.ie =
                  dadosCNPJ.estabelecimento.inscricoes_estaduais[0].inscricao_estadual;
              }

              if (dadosCNPJ.simples && dadosCNPJ.simples.simples === "Sim") {
                this.distribuidorMaster.crt = "1";
              } else {
                this.distribuidorMaster.crt = "3";
              }

              if (dadosCNPJ.estabelecimento.atividade_principal) {
                this.distribuidorMaster.cnae =
                  dadosCNPJ.estabelecimento.atividade_principal.id;
              }
            }
          } else {
            await Swal.fire({
              text: "O CNPJ informado é inválido!",
              icon: "warning",
              buttonsStyling: false,
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn fw-bold btn-warning",
              },
            });
          }
        } catch (error) {
          if (
            error.response &&
            error.response.data &&
            error.response.data.detalhes
          ) {
            await Swal.fire({
              text: error.response.data.detalhes,
              icon: "warning",
              buttonsStyling: false,
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn fw-bold btn-warning",
              },
            });
          } else {
            await Swal.fire({
              text: "Não foi possível localizar o CNPJ informado!",
              icon: "warning",
              buttonsStyling: false,
              confirmButtonText: "OK",
              customClass: {
                confirmButton: "btn fw-bold btn-warning",
              },
            });
          }
        }
      }
      this.loadingCNPJ = false;
    },
    async asyncData() {
      if (this.$route.params.id !== undefined) {
        this.loading = true;
        this.add = false;
        await this.carregarDistribuidorMaster();
      } else {
        this.add = true;
        this.limparDistribuidorMaster();
      }
    },
  },
  watch: {
    $route: {
      handler: "asyncData",
      immediate: true,
    },
  },
  mounted() {
    this.asyncData();
  },
  data() {
    return {
      loadingConfirmar: false,
      loadingCep: false,
      loading: false,
      loadingCNPJ: false,
      add: false,
      logoAtual: "",
      errosValidacao: [],
      exibirCidades: false,
      cidadeSelecionada: null,
      exibirPaises: false,
      paisSelecionado: null,
      errosGerais: {},
      distribuidorMaster: JSON.parse(
        JSON.stringify(distribuidorMasterInicializado)
      ),
    };
  },
};
</script>

<style>
.imagePreviewWrapper {
  background-size: contain !important;
  background-position: center !important;
}
</style>
